import { render, staticRenderFns } from "./EcodemolizioniTasksWidget.vue?vue&type=template&id=230e482a&scoped=true&"
import script from "./EcodemolizioniTasksWidget.vue?vue&type=script&lang=js&"
export * from "./EcodemolizioniTasksWidget.vue?vue&type=script&lang=js&"
import style0 from "./EcodemolizioniTasksWidget.vue?vue&type=style&index=0&id=230e482a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e482a",
  null
  
)

export default component.exports